<template>
  <div class="create-preorder-view">
    <Navbar v-if="!isDesktop" />
    <NavbarDesktop
      :cart="stage != 'details' ? cart.length : 0"
      :canCreate="canCreateOrder"
      :action="navbarAction"
      :currentMode="is_delivery ? 'delivery' : 'preorder'"
      :currentView="stage == 'menu' ? 'menu' : 'cart'"
      @onConfirmAction="onNavbarConfirmAction"
      @onDiscardAction="onNavbarDiscardAction"
      :canCreatePreorder="stage == 'precheck' ? true : !!waiting_time"
      :canStartOrderCreation="stage == 'details' ? are_details_ready : !!waiting_time"
      v-else
    />

    <div class="create-preorder-content">
      <PreorderCreationDetails
        class="creation-details"
        :value="details"
        :mode="is_delivery ? 'delivery' : 'preorder'"
        @input="(v) => (details = v)"
        @ready="(v) => (are_details_ready = v)"
        v-if="stage == 'details'"
      />

      <AddDish
        ref="addDish"
        @close="stage = 'details'"
        @add="onProductAdded"
        @select="(v) => (is_dish_selected = v)"
        :editing_order="false"
        v-if="stage == 'menu'"
      />

      <PreorderCard
        class="preorder-card-block"
        :preorder="fakeOrder"
        @setWaitingTime="(v) => (waiting_time = v)"
        @changeQuantity="onQuantityChanged"
        v-if="(stage == 'check' || stage == 'precheck') && !is_delivery"
      />

      <DeliveryCard
        class="preorder-card-block"
        :preorder="fakeOrder"
        @setWaitingTime="(v) => (waiting_time = v)"
        @changeQuantity="onQuantityChanged"
        v-if="(stage == 'check' || stage == 'precheck') && is_delivery"
      />
    </div>

    <div class="create-preorder-navbar" v-if="stage == 'precheck'">
      <img src="/icons/btn-back.svg" @click="stage = 'menu'" class="btn-back" />

      <QueueButton
        class="create-action-button"
        variant="accept"
        @click="stage = 'details'"
      >
        {{ $t("create_preorder.create_btn") }}
      </QueueButton>
    </div>

    <div class="create-preorder-navbar" v-if="stage == 'details'">
      <img src="/icons/btn-back.svg" @click="stage = 'precheck'" class="btn-back" />

      <small class="info" v-if="!are_details_ready">
        {{ $t("create_preorder.fill_fields") }}
      </small>

      <QueueButton
        v-if="are_details_ready"
        class="create-action-button"
        variant="accept"
        @click="stage = 'check'"
      >
        {{ $t("create_preorder.to_order") }}
      </QueueButton>
    </div>

    <div class="create-preorder-navbar" v-else-if="stage == 'menu'">
      <img
        src="/icons/btn-back.svg"
        @click="onNavbarDiscardAction"
        class="btn-back"
      />

      <small class="info" v-if="!is_dish_selected && !cart.length">
        {{ $t("add_dish.title") }}
      </small>

      <div v-else class="w-80">
        <QueueButton
          class="create-action-button w-100"
          variant="accept"
          @click="addToCart"
          v-if="!cart.length || is_dish_selected"
        >
          {{ $t("add_dish.add_to_cart") }}
        </QueueButton>
        <QueueButton
          class="create-action-button w-100"
          variant="confirm"
          @click="stage = 'precheck'"
          v-else
        >
          {{ $t("add_dish.go_to_cart") }}
          ({{ cart.length }} {{ $tc("add_dish.dishes_count", cart.length) }})
        </QueueButton>
      </div>
    </div>

    <div class="create-preorder-navbar" v-if="stage == 'check'">
      <img src="/icons/btn-back.svg" @click="stage = 'details'" class="btn-back" />

      <QueueButton
        class="create-action-button"
        variant="accept"
        @click="createOrder"
        :disabled="!waiting_time"
      >
        {{ $t("create_preorder.create_btn") }}
      </QueueButton>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import NavbarDesktop from "@/components/NavbarDesktop.vue";

import PreorderCreationDetails from "@/components/details/PreorderCreationDetails.vue";
import AddDish from "@/components/modals/AddDish.vue";
import PreorderCard from "@/components/preorder/PreorderCard.vue";
import DeliveryCard from "@/components/delivery/DeliveryCard.vue";

import moment from "moment";

import QueueButton from "@/components/QueueButton.vue";

import PreorderAPI from "@/api/preorder";

export default {
  data() {
    return {
      are_details_ready: false,

      details: null,
      waiting_time: null,
      is_delivery: false,

      cart: [],

      is_dish_selected: false,

      stage: "menu",
    };
  },
  components: {
    Navbar,
    NavbarDesktop,
    PreorderCreationDetails,
    QueueButton,
    AddDish,
    PreorderCard,
    DeliveryCard,
  },
  methods: {
    returnToOrders() {
      this.$router.push(
        `/orders?m=${this.is_delivery ? "delivery" : "preorder"}`
      );
    },
    addToCart() {
      this.$refs.addDish.uiContinue();
    },
    onProductAdded(item) {
      this.cart.push(item);
    },
    onQuantityChanged(index, delta) {
      const item = this.cart[index];

      if (item.quantity + delta <= 0) {
        this.cart.splice(index, 1);

        if (this.cart.length == 0) this.stage = "menu";
      } else {
        this.cart[index].quantity += delta;
      }
    },
    onNavbarConfirmAction() {
      if (this.stage == "menu") {
        if (this.is_dish_selected) {
          this.addToCart();
        } else {
          this.stage = "precheck";
        }
      } else if (this.stage == 'precheck') {
        this.stage = 'details';
      } else if (this.stage == "check") {
        this.createOrder();
      } else {
        this.stage = "check";
      }
    },
    createOrder() {
      const body = Object.assign({}, this.details);

      body.list = this.cart;
      body.waiting_time = this.waiting_time;
      body.is_delivery = this.is_delivery;

      delete body.details_inputs;

      PreorderAPI.createPreorder(body)
        .then((ok) => {
          this.returnToOrders();
        })
        .catch((error) => {
          this.$store.commit("setError", error);
        });
    },
    onNavbarDiscardAction() {
      if (this.stage == "details") {
        this.stage = 'menu';
      } else if (this.stage == "check") {
        this.stage = "details";
      } else if (this.stage == 'menu' && this.is_dish_selected) {
        this.$refs.addDish.uiCancel();
      } else if (this.stage == 'precheck') {
        this.stage = 'menu';
      } else {
        this.returnToOrders();
      }
    },
  },
  mounted() {
    if (!this.$store.state.initialized) {
      this.$store.dispatch("init");
    }

    this.is_delivery = this.$route.name == "create_delivery";
  },
  computed: {
    //To use PreorderCard we must supply a preorder object to it
    //so we create a fake one here :D
    fakeOrder() {
      if (!this.details) {
        return {
          client: null,
          status: 'creating',
          local_id: 'ABCD',
          is_delivery: this.is_delivery,
          created_at: new Date(),
          confirmed_at: new Date(),
          list: this.cart
        }
      }

      return {
        client: {
          name: this.details.name,
          phone: this.details.phone,
          address: this.details.address,
        },
        status: "editing",
        pay_method: this.details.pay_method,
        address_details: this.details.address_details,
        local_id: "ABCD",
        guests_count: this.details.guests_count,
        takeaway_date: this.details.takeaway_date,
        comment: this.details.comment,
        is_delivery: this.is_delivery,

        created_at: new Date(),
        confirmed_at: new Date(),

        list: this.cart,
      };
    },
    isDesktop() {
      return window.innerWidth > 768;
    },
    navbarAction() {
      if (this.stage == "details") {
        return {
          type: "goto_order",
        };
      }

      if (this.stage == "menu") {
        return {
          type: this.is_dish_selected ? "product-selected" : "selectDish",
        };
      }

      if (this.stage == 'check' || this.stage == 'precheck') {
        return {
          type: 'create-preorder'
        }
      }
    },
    canCreateOrder() {
      if (this.cart.length == 0) return false;

      if (this.stage == 'details') return false;

      return this.waiting_time;
    }
  },
};
</script>

<style scoped>

.create-preorder-view {
  position: relative;
  overflow-x: hidden;
}

.create-preorder-navbar {
  background: #1d1d1d;
  bottom: 0;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 1.3vh 3.2vh 2.6vh;
  z-index: 5;
  width: 100%;
  position: fixed;
  left: 0;
}

.btn-back {
  background: #e2223b;
  color: white;
  width: 6.2vh;
  height: 6.2vh;
  border-radius: 5vh;
  border: none;
}

.btn-back img {
  margin: 0 auto;
  display: block;
}

.create-action-button,
.w-80 {
  width: 80%;
}

.preorder-card-block {
  padding-top: 10vh;
  padding-bottom: 14vh;
}

@media screen and (min-width: 768px) {
  div.create-preorder-navbar {
    display: none;
  }

  .preorder-card-block {
    background: #ededed;
  }

  .creation-details,
  .preorder-card-block {
    padding-top: 20vh;
  }
}
</style>